import { useContext, useEffect } from "react";
import "./JuniorMemberPage.scss";
// import { useHistory } from "react-router-dom";
// import { usePathFactory } from "@sia/style-guide";
import { Workflow, useTranslator, useNavigator } from "@sia/style-guide";
import { useState } from "react";
import { WizarContext, initialWizardFormState } from "contexts/WizardContext";
import PersonalInfo from "./PersonalInfo";
import WorkPlaceInfo from "./WorkPlaceInfo";
import OtherAddressesInfo from "./OtherAddresses";
import EducationInfo from "./Education";
import SectionInfo from "./Sections";
import CommunicationInfo from "./Communication";
import Summary from "./Summary";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";

const JuniorMemberPage = () => {
  const translate = useTranslator();
  // const pathFactory = usePathFactory();
  // const history = useHistory();
  const { state } = useContext(WizarContext);
  const personalInfo = state.junior.personalInfo;
  const workplaceInfo = state.junior.workplaceInfo;
  const otherAddressesInfo = state.junior.otherAddressesInfo;
  const educationInfo = state.junior.educationInfo;
  const sectionInfo = state.junior.sectionInfo;

  const [errors, setErrors] = useState(initialWizardFormState);

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [shouldNavigateToNextStep, setShouldNavigateToNextStep] = useState(true);
  const [step, setStep] = useState(0);
  const navigate = useNavigator();

  const labels = {
    back: translate("wizard.form.single.button.back"),
    next: translate("wizard.form.single.button.next"),
    submit: translate("wizard.form.single.summary.button.label"),
    step: "Step",
    of: "Of",
  };

  const updatePersonalInfoErrors = () => {
    const exculdedProperties = ["phone", "mobile", "email"];
    const optionalProperties = ["additionalInfo"];
    let localShouldNavigateToNextStep = true;
    for (let property in personalInfo) {
      if (exculdedProperties.includes(property)) {
        const areSomePropertiesFilled = exculdedProperties.some((exculdedProperty) => personalInfo[exculdedProperty] !== "");
        if (areSomePropertiesFilled) {
          continue;
        } else {
          localShouldNavigateToNextStep = false;
          exculdedProperties.forEach((exculdedProperty) => {
            setErrors((errorState) => ({
              ...errorState,
              junior: {
                ...errorState.junior,
                personalInfo: { ...errorState.junior.personalInfo, [exculdedProperty]: translate("form.input.error.empty") },
              },
            }));
          });
        }
      } else if ((personalInfo[property] === "" || personalInfo[property] === null) && !optionalProperties.includes(property)) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          junior: {
            ...errorState.junior,
            personalInfo: { ...errorState.junior.personalInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
      setShouldNavigateToNextStep(localShouldNavigateToNextStep);
    }
  };

  const updateWorkplaceInfoErrors = () => {
    const optionalProperties = ["department"];
    const exculdedProperties = ["phone", "mobile", "email"];
    let localShouldNavigateToNextStep = true;
    for (let property in workplaceInfo) {
      if (exculdedProperties.includes(property)) {
        const areSomePropertiesFilled = exculdedProperties.some((exculdedProperty) => workplaceInfo[exculdedProperty] !== "");
        if (areSomePropertiesFilled) {
          continue;
        } else {
          localShouldNavigateToNextStep = false;
          exculdedProperties.forEach((exculdedProperty) => {
            setErrors((errorState) => ({
              ...errorState,
              junior: {
                ...errorState.junior,
                workplaceInfo: { ...errorState.junior.workplaceInfo, [exculdedProperty]: translate("form.input.error.empty") },
              },
            }));
          });
        }
      } else if ((workplaceInfo[property] === "" || workplaceInfo[property] === null) && !optionalProperties.includes(property)) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          junior: {
            ...errorState.junior,
            workplaceInfo: { ...errorState.junior.workplaceInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
      setShouldNavigateToNextStep(localShouldNavigateToNextStep);
    }
  };

  const updateOtherAddressInfoErrors = () => {
    let localShouldNavigateToNextStep = true;
    for (let property in otherAddressesInfo) {
      if (otherAddressesInfo[property] === "" || otherAddressesInfo[property] === null) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          junior: {
            ...errorState.junior,
            otherAddressesInfo: { ...errorState.junior.otherAddressesInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
      setShouldNavigateToNextStep(localShouldNavigateToNextStep);
    }
  };

  const updateEducationInfoErrors = () => {
    let localShouldNavigateToNextStep = true;
    const exculdedProperties = [
      "masterSchoolName",
      "masterStudyType",
      "masterGraduationDate",
      "masterTitle",
      "masterFile",
      "doctorateSchoolName",
      "doctorateStudyType",
      "doctorateGaduationDate",
      "doctorateTitle",
      "doctorateFile",
    ];
    for (let property in educationInfo) {
      if ((educationInfo[property] === "" || educationInfo[property] === null) && !exculdedProperties.includes(property)) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          junior: {
            ...errorState.junior,
            educationInfo: { ...errorState.junior.educationInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
      setShouldNavigateToNextStep(localShouldNavigateToNextStep);
    }
  };

  const updateSectionInfoErrors = () => {
    let localShouldNavigateToNextStep = true;
    for (let property in sectionInfo) {
      if (sectionInfo[property] === "" || sectionInfo[property] === null) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          junior: {
            ...errorState.junior,
            sectionInfo: { ...errorState.junior.sectionInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
      setShouldNavigateToNextStep(localShouldNavigateToNextStep);
    }
  };

  const checkForFormsError = () => {
    if (currentStepIndex === 0) {
      updatePersonalInfoErrors();
    }
    if (currentStepIndex === 1) {
      updateWorkplaceInfoErrors();
    }
    if (currentStepIndex === 2) {
      updateOtherAddressInfoErrors();
    }
    if (currentStepIndex === 3) {
      updateEducationInfoErrors();
    }
    if (currentStepIndex === 4) {
      updateSectionInfoErrors();
    }
  };

  const steps = [
    {
      label: translate("wizard.form.single.personal-info.label"),
      content: <PersonalInfo errors={errors} setErrors={setErrors} />,
    },
    {
      label: translate("wizard.form.single.work-place.label"),
      content: <WorkPlaceInfo errors={errors} setErrors={setErrors} />,
    },
    { label: translate("wizard.form.single.delivery-address.label"), content: <OtherAddressesInfo errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.single.education.label"), content: <EducationInfo errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.single.sections.label"), content: <SectionInfo errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.single.communication.title"), content: <CommunicationInfo errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.single.summary.label"), content: <Summary /> },
  ];

  useEffect(() => {
    if (shouldNavigateToNextStep) {
      setCurrentStepIndex(step);
    }
    if (step < currentStepIndex && !shouldNavigateToNextStep) {
      setShouldNavigateToNextStep(true);
    }
  }, [step, shouldNavigateToNextStep, currentStepIndex]);

  function submitForm() {
    let body = { form_data: { ...state.junior, is_junior: true } };
    pgAdapter.request("POST", "member_subscription/register_single", body, (data) => {
      if (data.status === 200) {
        navigate("");
      } else {
        // NOW WHAT?
      }
    });
  }

  return (
    <div className="single-member-page">
      <h3 className="single-member-page__heading productive-heading-04 sia-text-12 sia-margin-06-top sia-margin-05-bottom">
        {translate("wizard.title")}
      </h3>
      <Workflow
        steps={steps}
        labels={labels}
        slimContent={true}
        currentStepIndex={currentStepIndex}
        onNavigate={(newStepIndex) => {
          checkForFormsError();
          setStep(newStepIndex);
        }}
        onSubmit={() => submitForm()}
      />
    </div>
  );
};

export default JuniorMemberPage;
